import { render } from "./mandate.vue?vue&type=template&id=8a0584d8"
import script from "./mandate.vue?vue&type=script&lang=js"
export * from "./mandate.vue?vue&type=script&lang=js"

import "./mandate.vue?vue&type=style&index=0&id=8a0584d8&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__